const FOCUSABLE_TAGS = ['BUTTON', 'AHA-DS-BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT']
const CORRECT_ANSWER_SLIDE_TYPES = ['multipleChoice', 'imageChoice']

export const isCorrectAnswerHotkeyAvailable = ({ slideActive, sharePresentation }) => {
  if (sharePresentation || !slideActive || !slideActive.addCorrectOption) return false
  return CORRECT_ANSWER_SLIDE_TYPES.includes(slideActive.type)
}

export const isBareEnterPress = (event) => {
  if (event.code !== 'Enter') return false
  if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return false
  if (event.repeat) return false
  const targetTag = event.target && event.target.nodeName
  if (FOCUSABLE_TAGS.includes(targetTag)) return false
  const path = typeof event.composedPath === 'function' ? event.composedPath() : []
  return !path.some((node) => node && FOCUSABLE_TAGS.includes(node.nodeName))
}

export const shouldToggleCorrectAnswerOnKey = ({
  event, isPresenting, isCastingView, manualRevealCorrectAnswers, slideActive, sharePresentation,
}) => {
  if (!isBareEnterPress(event)) return false
  if (!isPresenting) return false
  if (isCastingView && manualRevealCorrectAnswers) return false
  return isCorrectAnswerHotkeyAvailable({ slideActive, sharePresentation })
}
